export default function getDefaultState () {
  return {
    order: null
  }
}
